import { useEffect } from 'react';
import { authService } from 'redux/utils/auth/authService';

/**
 * Listens for the app becoming visible (e.g. user returning from background or
 * switching back to the tab). When visible, validates/refreshes the session
 * token; if invalid or expired, logs the user out.
 *
 * Addresses iOS WebClip and mobile Safari behavior where JS is paused when
 * backgrounded, so the inactivity timer may not fire. On resume we check
 * session validity and logout if the token cannot be refreshed.
 */
const AuthVisibilityCheck = () => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') {
        return;
      }
      void authService.getToken().then(token => {
        if (token === null) {
          void authService.logout();
        }
      });
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return null;
};

export default AuthVisibilityCheck;
